module.exports = __webpack_public_path__ + "img/icon_contact_03.bf4b3c30.png";